import React from "react";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Application navigation error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <main className="app-error-fallback" data-testid="app-error-fallback"><img src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" /><span>Navigation interrupted</span><h1>Let’s get you back on track.</h1><p>The page could not be displayed correctly. Reload it or return to the homepage.</p><div><button type="button" onClick={() => window.location.reload()} data-testid="app-error-reload-button">Reload page</button><a href="/#/" data-testid="app-error-home-link">Return home</a></div></main>;
    }
    return this.props.children;
  }
}